module.exports = __webpack_public_path__ + "static/img/pic7.3ebee47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic7.png
// module id = u1Ss
// module chunks = 0